export default __webpack_public_path__ + "static/nitorfitness-2e21f1ad64f210809b022712f035a338.png";